<div class="container">
    <div
        *ngIf="(selectedUserType$ | async) === existingUser$">
        <div
            *ngIf="(accessLevel$ | async) === accessTypeSelection.INFORMATION_ONLY">
            <div
                class="align-items-center">
                <c11n-icon
                    class="custom-green-icon"
                    [name]="'success-fill'"
                    size="medium"
                    scale="larger"
                    data-cy="add-another-person-confirmation-icon">
                </c11n-icon>
            </div>
            <div class="zci-container-md" [id]="adobeLocationData">
                <div
                    class="c11n-space-stack-6x c11n-space--force">
                    <h1
                        class="c11n-text-2xl-headline c11n-space-stack-4x c11n-space--force c11n-space-inline-left-8x c11n-space-inline-right-8x"
                        data-cy="page-title">
                        {{
                            content.scssInformationAccessRequestSubmitted.text1
                                | replaceParam: addUserAccessNamePlaceHolder:(fullName$ | async)
                        }}
                    </h1>
                </div>
            </div>
        </div>

        <div
            *ngIf="(accessLevel$ | async) === accessTypeSelection.LIMITED_ACCESS">
            <div class="success-banner">
                <c11n-banner
                    size="small"
                    variant="success"
                    [isDetailsExpanded]="false"
                    [hasCloseControl]="false"
                    data-cy="add-another-person-confirmation-banner">
                    <div class="c11n-text-md--crop" role="alert">
                        {{ content.lstExistingLimitedSuccessMessage.scssLimitedAuthoritySubmitted }}
                    </div>
                </c11n-banner>
            </div>
            <div class="zci-container-md" [id]="adobeLocationData">
                <div
                    class="c11n-space-stack-6x c11n-space--force">
                    <p class="c11n-text-lg-headline c11n-space-stack-3x" data-cy="page-title">
                        {{ content.lstExistingLimitedSuccessMessage.heading }}
                    </p>
                    <div>
                        <ol
                            role="list"
                            class="c11n-list c11n-list--circles c11n-list--turquoise c11n-space-inline-left-3x">
                            <li class="c11n-space-stack-3x" data-cy="confirmation-content">
                                {{
                                    content.lstExistingLimitedSuccessMessage.listiWhatHappensNextSendMessage
                                        | replaceParam: 'userFullName':(fullName$ | async)
                                        | replaceParam: 'secondUserName':(fullName$ | async)
                                }}
                            </li>
                            <li class="c11n-space-stack-3x" data-cy="confirmation-content">
                                {{
                                    content.lstExistingLimitedSuccessMessage.listiWhatHappensNextEsign
                                        | replaceParam: 'userFullName':(fullName$ | async)
                                }}
                            </li>
                            <li class="c11n-space-stack-3x" data-cy="confirmation-content">
                                {{
                                    content.lstExistingLimitedSuccessMessage.listiWhatHappensNextAccessAccount.text1
                                        | replaceParam: 'userFullName':(fullName$ | async)
                                }}
                                <a
                                    c11n-link
                                    class="c11n-text-md-bold"
                                    variant="primary-reinforced"
                                    [routerLink]="'/'"
                                    (click)="resetGrantRevokePermissionState()"
                                    data-cy="access-center-link"
                                >{{ content.lstExistingLimitedSuccessMessage.listiWhatHappensNextAccessAccount.primaryCta }}</a
                                > {{
                                    content.lstExistingLimitedSuccessMessage.listiWhatHappensNextAccessAccount.text2
                                }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div
        *ngIf="newUser$ === (selectedUserType$ | async)">
        <div
            class="c11n-space-stack-6x c11n-space--force">
            <p class="c11n-text-2xl-headline c11n-space-stack-4x" data-cy="page-title">
                {{
                    content.lstNewGranteeNotOnListSuccessMessage.heading
                }}
            </p>
            <div>
                <ol
                    role="list"
                    class="c11n-list c11n-list--circles c11n-list--turquoise c11n-space-inline-left-3x">
                    <li class="" data-cy="confirmation-content">
                        <p class="c11n-text-md">{{ content.lstNewGranteeNotOnListSuccessMessage.listiWhatsNextUniquePin.heading | replaceParam: 'username':(firstName$ | async) }}</p> <br>
                        <zci-gaf-mvp-pin-component class="pin-button-margin-bottom" [uniquePin]="uniquePin"></zci-gaf-mvp-pin-component>
                        <div class="unique-pin-description c11n-text-sm" [innerHTML]="content.lstNewGranteeNotOnListSuccessMessage.listiWhatsNextUniquePin.text1"></div>
                    </li>
                    <li class="c11n-space-stack-3x c11n-text-md" data-cy="confirmation-content">
                        {{
                            content.lstNewGranteeNotOnListSuccessMessage.listiWhatsNextEmailLink | replaceParam: 'userName':(firstName$ | async)
                        }}
                    </li>
                    <li class="c11n-space-stack-3x c11n-text-md" data-cy="confirmation-content" [innerHTML]="                            content.lstNewGranteeNotOnListSuccessMessage.listiWhatsNextAccessToAccount | replaceParam: 'username':(firstName$ | async)">
                    </li>
                </ol>
            </div>
        </div>
    </div>

    <div class="button-wrapper">
        <c11n-button
            buttonType="button"
            size="medium"
            variant="primary"
            [labelText]="content.scssInformationAccessRequestSubmitted.navAddAnotherPerson"
            iconName="plus"
            iconPosition="leading"
            data-cy="add-another-person-button"
            (clickEvent)="goBackToTriage()"
            [fullWidth]="isMobileView$ | async"></c11n-button>
        <c11n-button
            *ngIf="(selectedUserType$ | async) === existingUser$"
            buttonType="button"
            size="medium"
            variant="secondary"
            [labelText]="content.scssInformationAccessRequestSubmitted.navGoToMyAccount"
            data-cy="go-to-my-accounts-button"
            [fullWidth]="isMobileView$ | async"
            (clickEvent)="tagMyAccountsAccessLevel()"
            [href]="accountBalancesUrl"></c11n-button>
        <c11n-button
            *ngIf="(selectedUserType$ | async) === newUser$"
            buttonType="button"
            size="medium"
            variant="secondary"
            [labelText]="content.lstNewGranteeNotOnListSuccessMessage.navReturnToAccessPermissions"
            data-cy="access-center-link"
            [fullWidth]="isMobileView$ | async"
            (clickEvent)="returnToAccessPermissions()"></c11n-button>
    </div>
</div>
